
export class Constantes  {

    public static readonly  PROPUESTA_EN_PROCESO: number = 1;
    public static readonly  PROPUESTA_ENVIADA: number = 2;
    public static readonly  PROPUESTA_RECHAZADA: number = 3;
    public static readonly  PROPUESTA_REVISADA: number = 4;
    public static readonly  PROPUESTA_APROBADA: number = 5;
}